module.exports = __webpack_public_path__ + "img/6-6.fa96a36f.png";